<template>
  <v-select
    v-model="model"
    :options="dataList"
    :label="labelsData.length ? 'customLabel' : labelData"
    :state="errors.length > 0 ? false : null"
    :placeholder="placeholder || defaultPlaceholder"
    :multiple="multiple"
    :filterable="false"
    @search="onSearch"
  >
    <!-- eslint-disable-next-line vue/no-unused-vars  -->
    <template #no-options="{ search, searching, loading }">
      <span v-if="searching">
        "{{ search }}" tidak ditemukan.
      </span>
      <span v-else>
        Cari {{ nameDefault }}...
      </span>
    </template>

    <template
      v-if="customOption"
      #option="data"
    >
      <slot
        name="option"
        :data="data"
      />
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    searchToLoad: {
      type: Boolean,
      default: false,
    },
    labelData: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    labelsData: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: undefined,
    },
    customOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataStateName: '',
      isSearching: false,
      dataList: [],
    }
  },
  computed: {
    ...mapState('brand', ['brandList']),
    ...mapState('user', ['users']),
    nameDefault() {
      const name = this.name.replace('-', ' ')

      return `${name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}`
    },
    defaultPlaceholder() {
      return `Pilih ${this.nameDefault}`
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    limit() {
      if (this.searchToLoad) return 10

      return 100
    },
    customLabel() {
      if (!this.labelData) {
        return {}
      }

      return {
        label: this.labelData,
      }
    },
  },
  async created() {
    if (!this.searchToLoad) {
      await this.loadData()
    }
  },
  methods: {
    ...mapActions('brand', ['getBrandList']),
    ...mapActions('user', ['getUserList']),
    async onSearch(text, loading) {
      if (this.searchToLoad) {
        if (text.length) {
          loading(true)
          this.searchData(loading, text, this, 1)
        }
      }
    },
    searchData: _.debounce((loading, search, that, page) => {
      that.loadData({ keyword: search, page }).finally(() => {
        loading(false)
      })
    }, 500),
    async loadData({ page = 1, keyword = undefined }) {
      const { name } = this

      // Merchant
      if (name === 'merchant') {
        const res = await this.getBrandList({
          limit: this.limit, page, keyword, hasSearch: true,
        })
        this.dataList = res.data
      }

      // User
      if (name === 'user') {
        const res = await this.getUserList({
          limit: this.limit, page, keyword, hasSearch: true,
        })
        this.dataList = res.data
      }

      // Add custom multiple label
      if (this.labelsData.length) {
        this.dataList = this.dataList.map(el => {
          const customLabel = []

          this.labelsData.forEach(ex => {
            customLabel.push(el[ex])
          })

          return { ...el, customLabel: customLabel.toString() }
        })
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
